export default __webpack_public_path__ + "static/media/Darkrend Tunic.610ed42d.jpg";